import { __module as h } from "./ghl-ui.es1683.js";
import { i as q } from "./ghl-ui.es1541.js";
import { g as p } from "./ghl-ui.es1684.js";
import { g as C } from "./ghl-ui.es1685.js";
import { g as D } from "./ghl-ui.es1686.js";
import { g as U } from "./ghl-ui.es1687.js";
import { g as _ } from "./ghl-ui.es1688.js";
import { a as G } from "./ghl-ui.es1689.js";
import { l as L } from "./ghl-ui.es1690.js";
(function(v, m) {
  var s = q.default;
  Object.defineProperty(m, "__esModule", {
    value: !0
  }), m.default = void 0;
  var l = s(p), x = s(C), b = s(D), y = s(U), T = s(_), o = s(G), d = s(L), c = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }, M = {
    // Era
    G: function(a, r, t) {
      var e = a.getUTCFullYear() > 0 ? 1 : 0;
      switch (r) {
        case "G":
        case "GG":
        case "GGG":
          return t.era(e, {
            width: "abbreviated"
          });
        case "GGGGG":
          return t.era(e, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return t.era(e, {
            width: "wide"
          });
      }
    },
    // Year
    y: function(a, r, t) {
      if (r === "yo") {
        var e = a.getUTCFullYear(), n = e > 0 ? e : 1 - e;
        return t.ordinalNumber(n, {
          unit: "year"
        });
      }
      return d.default.y(a, r);
    },
    // Local week-numbering year
    Y: function(a, r, t, e) {
      var n = (0, T.default)(a, e), u = n > 0 ? n : 1 - n;
      if (r === "YY") {
        var E = u % 100;
        return (0, o.default)(E, 2);
      }
      return r === "Yo" ? t.ordinalNumber(u, {
        unit: "year"
      }) : (0, o.default)(u, r.length);
    },
    // ISO week-numbering year
    R: function(a, r) {
      var t = (0, b.default)(a);
      return (0, o.default)(t, r.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(a, r) {
      var t = a.getUTCFullYear();
      return (0, o.default)(t, r.length);
    },
    // Quarter
    Q: function(a, r, t) {
      var e = Math.ceil((a.getUTCMonth() + 1) / 3);
      switch (r) {
        case "Q":
          return String(e);
        case "QQ":
          return (0, o.default)(e, 2);
        case "Qo":
          return t.ordinalNumber(e, {
            unit: "quarter"
          });
        case "QQQ":
          return t.quarter(e, {
            width: "abbreviated",
            context: "formatting"
          });
        case "QQQQQ":
          return t.quarter(e, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return t.quarter(e, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone quarter
    q: function(a, r, t) {
      var e = Math.ceil((a.getUTCMonth() + 1) / 3);
      switch (r) {
        case "q":
          return String(e);
        case "qq":
          return (0, o.default)(e, 2);
        case "qo":
          return t.ordinalNumber(e, {
            unit: "quarter"
          });
        case "qqq":
          return t.quarter(e, {
            width: "abbreviated",
            context: "standalone"
          });
        case "qqqqq":
          return t.quarter(e, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return t.quarter(e, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // Month
    M: function(a, r, t) {
      var e = a.getUTCMonth();
      switch (r) {
        case "M":
        case "MM":
          return d.default.M(a, r);
        case "Mo":
          return t.ordinalNumber(e + 1, {
            unit: "month"
          });
        case "MMM":
          return t.month(e, {
            width: "abbreviated",
            context: "formatting"
          });
        case "MMMMM":
          return t.month(e, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return t.month(e, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone month
    L: function(a, r, t) {
      var e = a.getUTCMonth();
      switch (r) {
        case "L":
          return String(e + 1);
        case "LL":
          return (0, o.default)(e + 1, 2);
        case "Lo":
          return t.ordinalNumber(e + 1, {
            unit: "month"
          });
        case "LLL":
          return t.month(e, {
            width: "abbreviated",
            context: "standalone"
          });
        case "LLLLL":
          return t.month(e, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return t.month(e, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // Local week of year
    w: function(a, r, t, e) {
      var n = (0, y.default)(a, e);
      return r === "wo" ? t.ordinalNumber(n, {
        unit: "week"
      }) : (0, o.default)(n, r.length);
    },
    // ISO week of year
    I: function(a, r, t) {
      var e = (0, x.default)(a);
      return r === "Io" ? t.ordinalNumber(e, {
        unit: "week"
      }) : (0, o.default)(e, r.length);
    },
    // Day of the month
    d: function(a, r, t) {
      return r === "do" ? t.ordinalNumber(a.getUTCDate(), {
        unit: "date"
      }) : d.default.d(a, r);
    },
    // Day of year
    D: function(a, r, t) {
      var e = (0, l.default)(a);
      return r === "Do" ? t.ordinalNumber(e, {
        unit: "dayOfYear"
      }) : (0, o.default)(e, r.length);
    },
    // Day of week
    E: function(a, r, t) {
      var e = a.getUTCDay();
      switch (r) {
        case "E":
        case "EE":
        case "EEE":
          return t.day(e, {
            width: "abbreviated",
            context: "formatting"
          });
        case "EEEEE":
          return t.day(e, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return t.day(e, {
            width: "short",
            context: "formatting"
          });
        case "EEEE":
        default:
          return t.day(e, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Local day of week
    e: function(a, r, t, e) {
      var n = a.getUTCDay(), u = (n - e.weekStartsOn + 8) % 7 || 7;
      switch (r) {
        case "e":
          return String(u);
        case "ee":
          return (0, o.default)(u, 2);
        case "eo":
          return t.ordinalNumber(u, {
            unit: "day"
          });
        case "eee":
          return t.day(n, {
            width: "abbreviated",
            context: "formatting"
          });
        case "eeeee":
          return t.day(n, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return t.day(n, {
            width: "short",
            context: "formatting"
          });
        case "eeee":
        default:
          return t.day(n, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone local day of week
    c: function(a, r, t, e) {
      var n = a.getUTCDay(), u = (n - e.weekStartsOn + 8) % 7 || 7;
      switch (r) {
        case "c":
          return String(u);
        case "cc":
          return (0, o.default)(u, r.length);
        case "co":
          return t.ordinalNumber(u, {
            unit: "day"
          });
        case "ccc":
          return t.day(n, {
            width: "abbreviated",
            context: "standalone"
          });
        case "ccccc":
          return t.day(n, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return t.day(n, {
            width: "short",
            context: "standalone"
          });
        case "cccc":
        default:
          return t.day(n, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // ISO day of week
    i: function(a, r, t) {
      var e = a.getUTCDay(), n = e === 0 ? 7 : e;
      switch (r) {
        case "i":
          return String(n);
        case "ii":
          return (0, o.default)(n, r.length);
        case "io":
          return t.ordinalNumber(n, {
            unit: "day"
          });
        case "iii":
          return t.day(e, {
            width: "abbreviated",
            context: "formatting"
          });
        case "iiiii":
          return t.day(e, {
            width: "narrow",
            context: "formatting"
          });
        case "iiiiii":
          return t.day(e, {
            width: "short",
            context: "formatting"
          });
        case "iiii":
        default:
          return t.day(e, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM or PM
    a: function(a, r, t) {
      var e = a.getUTCHours(), n = e / 12 >= 1 ? "pm" : "am";
      switch (r) {
        case "a":
        case "aa":
          return t.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          });
        case "aaa":
          return t.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "aaaaa":
          return t.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return t.dayPeriod(n, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM, PM, midnight, noon
    b: function(a, r, t) {
      var e = a.getUTCHours(), n;
      switch (e === 12 ? n = c.noon : e === 0 ? n = c.midnight : n = e / 12 >= 1 ? "pm" : "am", r) {
        case "b":
        case "bb":
          return t.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          });
        case "bbb":
          return t.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "bbbbb":
          return t.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return t.dayPeriod(n, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(a, r, t) {
      var e = a.getUTCHours(), n;
      switch (e >= 17 ? n = c.evening : e >= 12 ? n = c.afternoon : e >= 4 ? n = c.morning : n = c.night, r) {
        case "B":
        case "BB":
        case "BBB":
          return t.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          });
        case "BBBBB":
          return t.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return t.dayPeriod(n, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Hour [1-12]
    h: function(a, r, t) {
      if (r === "ho") {
        var e = a.getUTCHours() % 12;
        return e === 0 && (e = 12), t.ordinalNumber(e, {
          unit: "hour"
        });
      }
      return d.default.h(a, r);
    },
    // Hour [0-23]
    H: function(a, r, t) {
      return r === "Ho" ? t.ordinalNumber(a.getUTCHours(), {
        unit: "hour"
      }) : d.default.H(a, r);
    },
    // Hour [0-11]
    K: function(a, r, t) {
      var e = a.getUTCHours() % 12;
      return r === "Ko" ? t.ordinalNumber(e, {
        unit: "hour"
      }) : (0, o.default)(e, r.length);
    },
    // Hour [1-24]
    k: function(a, r, t) {
      var e = a.getUTCHours();
      return e === 0 && (e = 24), r === "ko" ? t.ordinalNumber(e, {
        unit: "hour"
      }) : (0, o.default)(e, r.length);
    },
    // Minute
    m: function(a, r, t) {
      return r === "mo" ? t.ordinalNumber(a.getUTCMinutes(), {
        unit: "minute"
      }) : d.default.m(a, r);
    },
    // Second
    s: function(a, r, t) {
      return r === "so" ? t.ordinalNumber(a.getUTCSeconds(), {
        unit: "second"
      }) : d.default.s(a, r);
    },
    // Fraction of second
    S: function(a, r) {
      return d.default.S(a, r);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(a, r, t, e) {
      var n = e._originalDate || a, u = n.getTimezoneOffset();
      if (u === 0)
        return "Z";
      switch (r) {
        case "X":
          return w(u);
        case "XXXX":
        case "XX":
          return f(u);
        case "XXXXX":
        case "XXX":
        default:
          return f(u, ":");
      }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(a, r, t, e) {
      var n = e._originalDate || a, u = n.getTimezoneOffset();
      switch (r) {
        case "x":
          return w(u);
        case "xxxx":
        case "xx":
          return f(u);
        case "xxxxx":
        case "xxx":
        default:
          return f(u, ":");
      }
    },
    // Timezone (GMT)
    O: function(a, r, t, e) {
      var n = e._originalDate || a, u = n.getTimezoneOffset();
      switch (r) {
        case "O":
        case "OO":
        case "OOO":
          return "GMT" + g(u, ":");
        case "OOOO":
        default:
          return "GMT" + f(u, ":");
      }
    },
    // Timezone (specific non-location)
    z: function(a, r, t, e) {
      var n = e._originalDate || a, u = n.getTimezoneOffset();
      switch (r) {
        case "z":
        case "zz":
        case "zzz":
          return "GMT" + g(u, ":");
        case "zzzz":
        default:
          return "GMT" + f(u, ":");
      }
    },
    // Seconds timestamp
    t: function(a, r, t, e) {
      var n = e._originalDate || a, u = Math.floor(n.getTime() / 1e3);
      return (0, o.default)(u, r.length);
    },
    // Milliseconds timestamp
    T: function(a, r, t, e) {
      var n = e._originalDate || a, u = n.getTime();
      return (0, o.default)(u, r.length);
    }
  };
  function g(i, a) {
    var r = i > 0 ? "-" : "+", t = Math.abs(i), e = Math.floor(t / 60), n = t % 60;
    if (n === 0)
      return r + String(e);
    var u = a || "";
    return r + String(e) + u + (0, o.default)(n, 2);
  }
  function w(i, a) {
    if (i % 60 === 0) {
      var r = i > 0 ? "-" : "+";
      return r + (0, o.default)(Math.abs(i) / 60, 2);
    }
    return f(i, a);
  }
  function f(i, a) {
    var r = a || "", t = i > 0 ? "-" : "+", e = Math.abs(i), n = (0, o.default)(Math.floor(e / 60), 2), u = (0, o.default)(e % 60, 2);
    return t + n + r + u;
  }
  var O = M;
  m.default = O, v.exports = m.default;
})(h, h.exports);
var k = h.exports;
export {
  k as f
};
